export default __webpack_public_path__ + "static/media/Madhya-Pradesh.db8b5a6d.jpg";